import axios from 'axios';

export default {
    searchLeads(fromInstant, toInstant) {
        return axios.get(window.API_BASE + '/api/v1/Leads/?fromInstant=' + fromInstant + '&toInstant=' + toInstant);
    }
}